import { render, staticRenderFns } from "./routePlan.vue?vue&type=template&id=b5a0c048&scoped=true&"
import script from "./routePlan.vue?vue&type=script&lang=js&"
export * from "./routePlan.vue?vue&type=script&lang=js&"
import style0 from "./routePlan.vue?vue&type=style&index=0&id=b5a0c048&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a0c048",
  null
  
)

export default component.exports